import { useState, useCallback } from 'react';
import { endOfWeek } from 'date-fns';

import useReportsHistory from 'data/hooks/useReportsHistory';
import { toApiDayFormat } from 'utils/date';
import { last2Week } from 'components/Form/WeekRangePicker/utils';
import { getWeekDays, getWeekRange } from 'utils/getWeek';
import useReport from 'data/hooks/useReports';
import { HoverRange } from 'data/types/hoverRange';
import { ReportType } from './types';

const useConnect = () => {
  const [reportType, setReportType] = useState<ReportType>('DEPOSIT_REPORT');

  const hoverRangeDefault = {
    from: undefined,
    to: undefined,
  };
  const [hoverRange, setHoverRange] = useState<HoverRange>(hoverRangeDefault);
  const [selectedDays, setSelectedDays] = useState<Date[]>(
    getWeekDays(last2Week),
  );
  const handleDayChange = (date: Date) => {
    const days = getWeekDays(date);
    setSelectedDays(days);
  };
  const handleDayEnter = (date: Date) => {
    const days = getWeekRange(date);
    setHoverRange(days);
  };
  const handleDayLeave = () => {
    setHoverRange(hoverRangeDefault);
  };
  const handleWeekClick = (weekNumber: any, days: Date[]) => {
    setSelectedDays(days);
  };

  const {
    reports,
    isFetchingNextPage,
    isFetching,
    hasNextPage,
    fetchNextPage,
  } = useReportsHistory();

  const { requestReport, isLoading: isRequestReportLoading } = useReport();

  const datesCopy = [...selectedDays];
  const firstDate = datesCopy.shift();
  const lastDate = datesCopy.pop();
  const handleRequestReport = useCallback(
    () =>
      requestReport({
        reportType: 'deposit',
        // @ts-ignore
        dateStart: toApiDayFormat(firstDate),
        // @ts-ignore
        dateEnd: toApiDayFormat(lastDate),
      }),
    [firstDate, lastDate, requestReport],
  );

  return {
    hoverRange,
    selectedDays,
    handleDayChange,
    handleDayEnter,
    handleDayLeave,
    handleWeekClick,
    fromLimit: new Date('Sat Jan 1 2022'),
    toLimit: endOfWeek(last2Week, { weekStartsOn: 1 }),

    reportType,
    setReportType,
    handleRequestReport,
    isRequestReportLoading,

    reports,
    isFetchingNextPage,
    isFetching,
    hasNextPage,
    fetchNextPage,
  };
};

export default useConnect;
